import { CheckIcon, ClearIcon, IconFillColor, IconSize, IconWrapper } from '@dreryk/react-components';

type AcceptButtonProps = {
   testId: string;
   onClick: VoidFunction;
};

export const AcceptButton = (props: AcceptButtonProps): JSX.Element => (
   <IconWrapper size={IconSize.NORMAL} testId={props.testId} fillColor={IconFillColor.SUCCESS} onClick={props.onClick}>
      <CheckIcon />
   </IconWrapper>
);

type RejectButtonProps = {
   testId: string;
   onClick: VoidFunction;
};

export const RejectButton = (props: RejectButtonProps): JSX.Element => (
   <IconWrapper size={IconSize.NORMAL} testId={props.testId} fillColor={IconFillColor.ERROR} onClick={props.onClick}>
      <ClearIcon />
   </IconWrapper>
);
